import { useCallback, useRef, useState } from "react";

interface UseCopyToClipboardOptions {
  resetMs?: number;
}

interface UseCopyToClipboardResult {
  copiedKey: string | null;
  copy: (text: string, key: string) => Promise<void>;
}

export function useCopyToClipboard(
  options?: UseCopyToClipboardOptions,
): UseCopyToClipboardResult {
  const resetMs = options?.resetMs ?? 2000;
  const [copiedKey, setCopiedKey] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const copy = useCallback(
    async (text: string, key: string) => {
      await navigator.clipboard.writeText(text);

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      setCopiedKey(key);
      timerRef.current = setTimeout(() => {
        setCopiedKey(null);
      }, resetMs);
    },
    [resetMs],
  );

  return { copiedKey, copy };
}
